document.addEventListener('DOMContentLoaded', function () {
  const isMobile = window.matchMedia("(max-width: 768px)").matches;
    var coreStorySlider = new Swiper('.core-story-slider', {
      slidesPerView: 3,
      spaceBetween: 20,
      loop: false,
      autoplay: false,
      pagination: false,
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev'
      },
      slidesPerGroup: 1,
      breakpoints: {
        1025: { slidesPerView: 3 },
        768: { slidesPerView: 2 },
        0: { slidesPerView: 1.2 }
      },
      mousewheel: isMobile ? false : {
        forceToAxis: true,
        invert: false,
        sensitivity: 1,
        releaseOnEdges: true,
      },
      freeMode: isMobile ? false : {
          enabled: true,
          sticky: true,
      },
      containerModifierClass: 'swiper-container-',
    });
  });
